export default "__VITE_ASSET__zsWD4a3Z__"